// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import {
  sanitizeNumberAcceptingDotAndMinus,
  stripExceptNumbersHyphensPeriods,
} from 'utils/sanitizeTextToNumberField';
import { _NumberToFix } from 'utils/v1.1/_Number';
import PropTypes from 'prop-types';
import InputField from '../atoms/InputField';
import { isDecimal } from '../../utils/v1.1/NumberUtils';

const FieldWithDecimalControlled = ({
  placeholder,
  name,
  value,
  onChange,
  startAdornment,
  handleKeyPress,
  onFocus,
  onBlur,
  decimalPoint = 12,
  inputRef,
  ...rest
}) => {
  const [isBlurred, setIsBlurred] = useState(true);
  const fieldRef = useRef();

  const refToUse = inputRef || fieldRef;

  useEffect(() => {
    if (!isBlurred) {
      refToUse.current?.select();
    }
  }, [isBlurred, refToUse]);

  const handleFocus = (e) => {
    e.target.select();
    setIsBlurred(false);
    if (typeof onFocus === 'function') onFocus(e);
  };

  const handleBlur = (e) => {
    setIsBlurred(true);
    if (typeof onBlur === 'function') onBlur(e);
  };

  const handleChange = (e) => {
    const {
      target: { value, name },
    } = e;
    if (e.target.value.split('.')?.[1]?.length > decimalPoint) return;
    onChange({
      target: { name, value: stripExceptNumbersHyphensPeriods(value) },
    });
  };

  const formatValue = (v) => {
    if (isBlurred && isDecimal(v)) {
      return _NumberToFix(v);
    }
    return v;
  };

  return (
    <InputField
      {...rest}
      inputRef={refToUse}
      placeholder={placeholder}
      name={name}
      value={formatValue(value)}
      onKeyPress={handleKeyPress || sanitizeNumberAcceptingDotAndMinus}
      onChange={handleChange}
      startAdornment={startAdornment}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};

FieldWithDecimalControlled.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  startAdornment: PropTypes.any,
  handleKeyPress: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  decimalPoint: PropTypes.number,
  inputRef: PropTypes.any,
};

export default FieldWithDecimalControlled;
